import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useLoginByToken = () => {
    const send = useGenericSend();

    return useCallback(async (
        request: Types.ILoginByTokenRequestData,
        options?: { signal?: AbortSignal }
    ): Promise<Types.ILoginByTokenResponseData> => {
        const { data } = await send<Types.ILoginByTokenRequestData, Types.ILoginByTokenResponseData>({
            ID: 33036,
            responses: [31002, 31009],
            description: 'Login with existing Session token',
            logoutOnDisconnectBehaviour: 'hierarchical',
            logoutOnDisconnect: true,
            waitingMessages: false,
            ...request
        }, options);

        return data;
    }, [
        send
    ]);
};
